// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.certificatesection-inline-1 {
  margin-top: 16px;
}

.certificatesection-inline-2 {
  font-size: 11px;
  color: var(--text-muted);
  margin-top: 6px;
}

.certificatesection-dyn-1 {
  height: 6px;
  background: var(--certificatesection-1-background);
  border-radius: 6px;
  overflow: hidden;
  max-width: 240px;
  margin: 0 auto;
}

.certificatesection-dyn-2 {
  height: 100%;
  width: var(--certificatesection-2-width);
  background: linear-gradient(90deg,#4f46e5,#818cf8);
  border-radius: 6px;
  transition: width 1s ease;
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/Intern/CertificateSection.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kDAAkD;EAClD,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,wCAAwC;EACxC,kDAAkD;EAClD,kBAAkB;EAClB,yBAAyB;AAC3B","sourcesContent":[".certificatesection-inline-1 {\n  margin-top: 16px;\n}\n\n.certificatesection-inline-2 {\n  font-size: 11px;\n  color: var(--text-muted);\n  margin-top: 6px;\n}\n\n.certificatesection-dyn-1 {\n  height: 6px;\n  background: var(--certificatesection-1-background);\n  border-radius: 6px;\n  overflow: hidden;\n  max-width: 240px;\n  margin: 0 auto;\n}\n\n.certificatesection-dyn-2 {\n  height: 100%;\n  width: var(--certificatesection-2-width);\n  background: linear-gradient(90deg,#4f46e5,#818cf8);\n  border-radius: 6px;\n  transition: width 1s ease;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
